import CryptoJS from "crypto-js";
import config from "../config";

const roles = {
  admin: {
    RAISE_REQUEST: true,
    LANDING_PAGE: true,
    AGENCY_APPROVAL: true,
    REVIEW: true,
    REVIEW_LIST: true,
    SEND_NOTIFICATION: true,
    SEND_ALL_NOTIFICATION: true,
    AGENCY: true,
    USER_IMAGE_CARD: true,
    UPLOAD_DOCUMENTS: true,
    USER_IMAGE_UNDER_REVIEW_CARD: false,
    PACKAGES_TAB: true,
    QUICK_MEET: true,
    IMAGES_REVIEWS: true,
    QUOTATION: true,
    ADD_EVENT_BREAKDOWN: true,
    UPLOAD_INDIVIDUAL_DOCS: false,
    APPROVE_PACKAGES: false,
    VENDOR: false,
    EDIT_EVENT: true,
    BREAKDOWN: true,
    SHOW_CVENT_BANNER: true,
    DASHBOARD: true,
    ALL_DASHBOARD: false,
    ADMIN: true,
    SHOW_POLICY: true,
    COST_BENCHMARKING: true,
    TRAVEL_PARTNERS: true,
    ARCHIVED_FOLDER: true,
    BENCHMARK_DATA: true,
    INVOICE: true
  },
  initiator: {
    RAISE_REQUEST: true,
    LANDING_PAGE: true,
    AGENCY_APPROVAL: true,
    REVIEW: false,
    REVIEW_LIST: false,
    SEND_NOTIFICATION: true,
    SEND_ALL_NOTIFICATION: false,
    AGENCY: true,
    USER_IMAGE_CARD: false,
    UPLOAD_DOCUMENTS: true,
    USER_IMAGE_UNDER_REVIEW_CARD: true,
    PACKAGES_TAB: true,
    QUICK_MEET: true,
    IMAGES_REVIEWS: true,
    QUOTATION: true,
    ADD_EVENT_BREAKDOWN: true,
    UPLOAD_INDIVIDUAL_DOCS: false,
    APPROVE_PACKAGES: true,
    VENDOR: false,
    EDIT_EVENT: true,
    BREAKDOWN: true,
    SHOW_CVENT_BANNER: false,
    DASHBOARD: true,
    ALL_DASHBOARD: true,
    ADMIN: false,
    SHOW_POLICY: true,
    COST_BENCHMARKING: true,
    TRAVEL_PARTNERS: false,
    ARCHIVED_FOLDER: false,
    BENCHMARK_DATA: false,
    INVOICE: false
  },
  employee: {
    RAISE_REQUEST: true,
    LANDING_PAGE: true,
    AGENCY_APPROVAL: false,
    REVIEW: false,
    REVIEW_LIST: false,
    SEND_NOTIFICATION: false,
    SEND_ALL_NOTIFICATION: false,
    AGENCY: true,
    USER_IMAGE_CARD: false,
    UPLOAD_DOCUMENTS: false,
    USER_IMAGE_UNDER_REVIEW_CARD: true,
    PACKAGES_TAB: true,
    QUICK_MEET: false,
    IMAGES_REVIEWS: true,
    QUOTATION: false,
    ADD_EVENT_BREAKDOWN: false,
    UPLOAD_INDIVIDUAL_DOCS: false,
    APPROVE_PACKAGES: false,
    VENDOR: false,
    EDIT_EVENT: false,
    BREAKDOWN: true,
    SHOW_CVENT_BANNER: false,
    DASHBOARD: false,
    ALL_DASHBOARD: false,
    ADMIN: false,
    SHOW_POLICY: true,
    COST_BENCHMARKING: false,
    TRAVEL_PARTNERS: false,
    ARCHIVED_FOLDER: false,
    BENCHMARK_DATA: false,
    INVOICE: false
  },
  External_employee: {
    RAISE_REQUEST: false,
    LANDING_PAGE: true,
    AGENCY_APPROVAL: false,
    REVIEW: false,
    REVIEW_LIST: false,
    SEND_NOTIFICATION: false,
    SEND_ALL_NOTIFICATION: false,
    AGENCY: false,
    USER_IMAGE_CARD: false,
    UPLOAD_DOCUMENTS: false,
    USER_IMAGE_UNDER_REVIEW_CARD: true,
    PACKAGES_TAB: true,
    QUICK_MEET: false,
    IMAGES_REVIEWS: true,
    QUOTATION: false,
    ADD_EVENT_BREAKDOWN: false,
    UPLOAD_INDIVIDUAL_DOCS: false,
    APPROVE_PACKAGES: false,
    VENDOR: false,
    EDIT_EVENT: false,
    BREAKDOWN: false,
    SHOW_CVENT_BANNER: false,
    DASHBOARD: false,
    ALL_DASHBOARD: false,
    ADMIN: false,
    SHOW_POLICY: false,
    COST_BENCHMARKING: false,
    TRAVEL_PARTNERS: false,
    ARCHIVED_FOLDER: false,
    BENCHMARK_DATA: false,
    INVOICE: false
  },
  vendor: {
    RAISE_REQUEST: false,
    LANDING_PAGE: false,
    AGENCY_APPROVAL: false,
    REVIEW: true,
    REVIEW_LIST: false,
    SEND_NOTIFICATION: true,
    SEND_ALL_NOTIFICATION: false,
    AGENCY: false,
    USER_IMAGE_CARD: false,
    UPLOAD_DOCUMENTS: false,
    USER_IMAGE_UNDER_REVIEW_CARD: false,
    PACKAGES_TAB: true,
    QUICK_MEET: false,
    IMAGES_REVIEWS: false,
    QUOTATION: true,
    ADD_EVENT_BREAKDOWN: true,
    UPLOAD_INDIVIDUAL_DOCS: true,
    APPROVE_PACKAGES: false,
    VENDOR: true,
    EDIT_EVENT: false,
    BREAKDOWN: true,
    SHOW_CVENT_BANNER: false,
    DASHBOARD: false,
    ALL_DASHBOARD: false,
    ADMIN: false,
    SHOW_POLICY: false,
    COST_BENCHMARKING: false,
    TRAVEL_PARTNERS: false,
    ARCHIVED_FOLDER: false,
    BENCHMARK_DATA: false,
    INVOICE: true
  },
};
export function hasPermission(screen) {
  const content = sessionStorage.getItem("content");

  if (content) {
    const bytes = CryptoJS.AES.decrypt(content, config.userKey);
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    const userInfo = JSON.parse(jsonString);
    if (userInfo && userInfo.role) {
      if (roles[userInfo.role][screen]) {
        return true;
      }
      return false;
    }
  }
  return false;
}

export const statusMap = [
  "event_request",
  "event_upcoming",
  "event_started",
  "event_completed",
];
